module.exports = __webpack_public_path__ + "img/bookingcom.61f6827a.svg";